import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './locales/en_EN.json'
import hu from './locales/hu_HU.json'

Vue.use(VueI18n)

const messages = {
  en: {
    ...en
  },
  hu: {
    ...hu
  }
}
export default new VueI18n(
  {
    // locale: navigator.language.split('-')[0],
    locale: 'en',
    fallbackLocale: 'en',
    messages
  }
)
